import { render, staticRenderFns } from "./serviceSwift.vue?vue&type=template&id=3907318a&scoped=true&"
import script from "./serviceSwift.vue?vue&type=script&lang=js&"
export * from "./serviceSwift.vue?vue&type=script&lang=js&"
import style0 from "./serviceSwift.vue?vue&type=style&index=0&id=3907318a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907318a",
  null
  
)

export default component.exports